import React from "react";
import VideoContent from "../../content/VideoContent";

export default function VideoWrapper({ step, style, handleUpdateText }) {
    return (
        <VideoContent step={step} style={style} handleUpdateText={handleUpdateText} />
    );
}